/**
 * App-wide constants. Change these to customize the app branding.
 *
 * APP_TITLE is used for: browser tab title (index.tsx), header (Dashboard).
 * If you change it here, also update public/index.html <title> and
 * public/manifest.json "name" / "short_name" for consistency.
 */
export const APP_TITLE = 'Meeting Notes';
